// Same rule as the backend's bulk threshold: new-device orders with more devices than this in total
// go through the bulk endpoint, which creates the devices in the background.
export const BULK_ORDER_THRESHOLD = 100
